var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-spinner",style:(_vm.computedStyle)},[_c('div',{staticClass:"circle circle-1"}),_c('div',{staticClass:"circle circle-2"})])}
var staticRenderFns = []

export { render, staticRenderFns }